import React from 'react';

export default function ProductDescription({ description }) {
  if (!description) return null;

  const rawLines = description.split('\n').map(l => l.trim());
  const lines = [];
  for (const l of rawLines) {
    if (l === '' && lines[lines.length - 1] === '') continue;
    lines.push(l);
  }

  return (
    <div className="space-y-3">
      {lines.map((line, i) => {
        if (line === '') return <div key={i} className="h-2" />;

        if (/^\*+/.test(line)) {
          const text = line.replace(/^\*+\s*/, '').replace(/\*+\s*$/, '');
          return (
            <p key={i} className="text-primary text-xs font-bold tracking-wide">
              {text}
            </p>
          );
        }

        if (/^[✅\u2705✔]/.test(line)) {
          const text = line.replace(/^[✅\u2705✔]\s*/, '');
          return (
            <div key={i} className="flex items-start gap-2.5">
              <span className="text-primary text-sm leading-6 mt-px">✓</span>
              <span className="text-white/70 leading-6">{text}</span>
            </div>
          );
        }

        if (/^key features:?\s*$/i.test(line)) {
          return (
            <p key={i} className="text-white font-bold text-xs tracking-widest uppercase pt-1">
              Key Features
            </p>
          );
        }

        if (i === 0) {
          return (
            <p key={i} className="text-white font-bold text-base leading-snug">
              {line}
            </p>
          );
        }

        return (
          <p key={i} className="text-white/50 leading-relaxed">
            {line}
          </p>
        );
      })}
    </div>
  );
}